import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAnnouncementPopup } from '@app/shared/models/announcement-popups.model';
import { AnnouncementDialogFacade } from '@app/shared/store/announcement-dialog/announcement-dialog-facade';

@Component({
  selector: 'app-announcement-dialog',
  templateUrl: './announcement-dialog.component.html',
  styleUrls: ['./announcement-dialog.component.scss'],
})
export class AnnouncementDialogComponent implements OnInit {
  public announcement?: IAnnouncementPopup;
  public dontShowAgain: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<AnnouncementDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      announcement: IAnnouncementPopup;
    },
    private announcementDialogFacade: AnnouncementDialogFacade
  ) {}

  ngOnInit() {
    this.announcement = this.data.announcement;
  }

  public closeDialogHandler() {
    this.announcementDialogFacade.setDontShowAgain(this.dontShowAgain);
    this.dialogRef.close();
  }

  public submitButtonAction() {
    if (this.announcement?.cta_url) {
      this.announcementDialogFacade.setDontShowAgain(this.dontShowAgain);
      window.location.href = this.announcement.cta_url;
    }

    this.dialogRef.close();
  }
}
